import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row.exclusions');

const ExcludeHiredCheckbox = () => {
  const { watch, setValue } = useFormContext();
  const excludeHired: boolean = watch('exclude_hired');

  return (
    <Checkbox
      data-provides={'talent-matching-exclude-hired-checkbox'}
      checked={excludeHired}
      onChange={(checked) =>
        setValue('exclude_hired', checked, { shouldDirty: true })
      }
      label={t('hired_at_your_organization')}
      value={'exclude_hired'}
    />
  );
};

export default ExcludeHiredCheckbox;
